<div class="grid grid-cols-1 gap-1 my-2 justify-items-center">
    <img class="w-3/4" src="../../../../../../assets/images/cdft/wellSubsidence.png" />
</div>


<form [formGroup]="formGroup" class="grid grid-cols-1 gap-2 my-2">
    <div class="my-2">
        <div class="grid grid-cols-4 gap-2">
            <mat-label class="col-span-3">
                Vertical depth from PCV to Cellar Deck, Datum Point #1
            </mat-label>
            <mat-form-field class="w-full col-span-1">
                <input matInput class="input" formControlName="pcvPoint1" type="number" />
                <span matTextSuffix>cm</span>
            </mat-form-field>
        </div>
    </div>
    <div class="my-2">
        <div class="grid grid-cols-4 gap-2">
            <mat-label class="col-span-3">
                Vertical depth from ICV to Cellar Deck, Datum Point #2
            </mat-label>
            <mat-form-field class="w-full col-span-1">
                <input matInput class="input" formControlName="icvPoint2" type="number" />
                <span matTextSuffix>cm</span>
            </mat-form-field>
        </div>
    </div>
    <div class="my-2">
        <div class="grid grid-cols-4 gap-2">
            <mat-label class="col-span-3">
                Vertical depth from SCV to Cellar Deck, Datum Point #2
            </mat-label>
            <mat-form-field class="w-full col-span-1">
                <input matInput class="input" formControlName="scvPoint2" type="number" />
                <span matTextSuffix>cm</span>
            </mat-form-field>
        </div>
    </div>
    <div class="my-2">
        <div class="grid grid-cols-4 gap-2">
            <mat-label class="col-span-3">
                Vertical depth from CCV to Cellar Deck, Datum Point #3
            </mat-label>
            <mat-form-field class="w-full col-span-1">
                <input matInput class="input" formControlName="ccvPoint3" type="number" />
                <span matTextSuffix>cm</span>
            </mat-form-field>
        </div>
    </div>
</form>
<form [formGroup]="formGroup" class="grid grid-cols-2 gap-2">
    <div class="my-2 col-span-2">
        <mat-label> Wellhead Subsidence Observation </mat-label>
    </div>
    <div class="my-2 col-span-1">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>Result</mat-label>

            <mat-select matNativeControl formControlName="result">
                <mat-select-trigger class="rounded">
                    <span class="p-2 font-semibold" [ngClass]="{
            'bg-good': formGroup.get('result')?.value === 'Normal',
            'bg-failed': formGroup.get('result')?.value === 'Abnormal'
          }">
                        {{ formGroup.get('result')?.value || 'Select Result' }}
                    </span>
                </mat-select-trigger>
                <mat-option value="Normal">
                    <div class="bg-good p-2 rounded text-center text-black w-20">Normal</div>
                </mat-option>

                <mat-option value="Abnormal">
                    <div class="bg-failed p-2 rounded text-center text-black w-20">Abnormal</div>
                </mat-option>
            </mat-select>

            <!-- <input type="text" matInput formControlName="result" [matAutocomplete]="result"
            class=" p-2 rounded text-center font-semibold"
            [ngClass]="{
                'bg-good' : formGroup.get('result')?.value == 'Normal',
                'bg-failed' : formGroup.get('result')?.value == 'Abnormal',
            }" />
            <mat-autocomplete autoActiveFirstOption #result="matAutocomplete">
                <mat-option value="Normal">Normal</mat-option>
                <mat-option value="Abnormal">Abnormal</mat-option>
            </mat-autocomplete> -->
        </mat-form-field>
    </div>
    <div class="my-2 col-span-2">
        <mat-label> Wellhead Subsidence Remark </mat-label>
        <mat-form-field class="w-full">
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="10"
                formControlName="remark"></textarea>
        </mat-form-field>
    </div>
</form>